export default "__VITE_ASSET__Md01ogHn__"